/**
 * COTTONWAYS CUSTOM VARIANT DROPDOWNS
 * Visual layer over Shopify .single-option-selector elements.
 */
(function () {
  /* eslint-disable no-var */
  var INIT_ATTR = 'data-cw-vd-bound';
  var FORM_CLASS = 'cw-vd-ready';
  var FAIL_ATTR = 'data-cw-vd-failed';
  var SKIP_ATTR = 'data-cw-vd-skipped';

  var cottonwaysColors = {
    acacia: '#FFE331',
    amazon: '#C1B554',
    amethyst: '#BFA4DF',
    aqua: '#8EDBE0',
    avocado: '#95976D',
    azalea: '#A62337',
    azure: '#667CC4',
    black: '#222222',
    brick: '#542327',
    caspian: '#394CA5',
    /* typo alias → Citrus (exact-match lookup only; size-suffix stripping not yet implemented) */
    cirtus: '#F57C00',
    citrus: '#F57C00',
    cloud: '#B2D5F3',
    cocoa: '#9B7177',
    coffee: '#503229',
    'coffee bean': '#503229',
    coral: '#E16664',
    crystal: '#78B1BF',
    eggplant: '#55316C',
    /* Fire Coral is the same canonical color as Fire */
    fire: '#B63436',
    'fire coral': '#B63436',
    'green apple': '#C5E3B8',
    heather: '#D7B4D2',
    indigo: '#286199',
    ink: {
      type: 'texture',
      value:
        'radial-gradient(ellipse 85% 70% at 22% 40%, #17191D 0 36%, #292C33 44%, #41465A 50%, #62677D 54%, transparent 62%), ' +
        'radial-gradient(ellipse 40% 48% at 78% 78%, #17191D 0 18%, #41465A 26%, transparent 38%), ' +
        'radial-gradient(ellipse 55% 22% at 48% 12%, #292C33 0 10%, #62677D 16%, transparent 28%), ' +
        'linear-gradient(180deg, #F2F0EC 0%, #F2F0EC 100%)'
    },
    iron: '#4A5362',
    island: '#36BCD0',
    ivory: '#F4F3E8',
    'jade forest': '#25854B',
    /* typo/alias → Amethyst (exact-match lookup only) */
    'light amethyst': '#BFA4DF',
    lilac: '#7F6394',
    'lilac frost': '#F7E8F3',
    'lime frost': '#DDE29A',
    limeade: '#CCD56D',
    magenta: '#C92E3D',
    mango: '#D07D2E',
    marble: '#6D6C70',
    marina: '#245693',
    mint: '#9CCDC9',
    mustard: '#F7C500',
    olive: '#7D8500',
    /* Cottonways Dark Olive (hang tag: DK OLIVE). Not Olive #7D8500.
       Vendor-scoped — do not add to Léa & Luc; they share the name. */
    'dark olive': '#696050',
    'dk olive': '#696050',
    'peach pink': '#F7C0B7',
    peacock: {
      type: 'texture',
      value:
        'radial-gradient(ellipse 52% 40% at 68% 22%, #18A4AA 0 16%, transparent 34%), ' +
        'radial-gradient(ellipse 75% 68% at 28% 70%, #075769 0 28%, #076C82 42%, transparent 58%), ' +
        'radial-gradient(ellipse 36% 48% at 82% 62%, #075769 0 18%, transparent 36%), ' +
        'radial-gradient(ellipse 28% 20% at 48% 12%, #078E9C 0 12%, transparent 26%), ' +
        'linear-gradient(180deg, #087D8D 0%, #087D8D 100%)'
    },
    periwinkle: '#B0B1EA',
    'pop pink': '#DF5095',
    primrose: '#DFA1DB',
    putty: '#7B645E',
    /* Rose and Rosée are DIFFERENT colors — never merge */
    rose: '#B52F45',
    'rose quartz': '#E08A91',
    'rosée': '#FAE2E0',
    /* catalog spelling without accent → Rosée (NOT Rose) */
    rosee: '#FAE2E0',
    rust: '#7D403B',
    sage: '#8EBEAA',
    sahara: '#C14522',
    salsa: '#ED321C',
    sangria: '#C05B79',
    sea: '#38777B',
    seaglass: '#C9F4E0',
    /* typo alias → Seaglass (exact-match lookup only) */
    sealgass: '#C9F4E0',
    silver: '#D7E0EB',
    spice: '#4A2E2C',
    stone: '#B9A9A1',
    stream: '#61A68F',
    sunflower: '#FFF46A',
    titanium: '#51464B',
    /* typo alias → Titanium (exact-match lookup only) */
    titianium: '#51464B',
    topaz: {
      type: 'texture',
      value:
        'radial-gradient(ellipse 70% 55% at 22% 28%, #36B7D5 0 22%, transparent 40%), ' +
        'radial-gradient(ellipse 48% 62% at 78% 72%, #16478E 0 20%, #075BA7 32%, transparent 48%), ' +
        'radial-gradient(ellipse 38% 26% at 42% 86%, #075BA7 0 12%, transparent 28%), ' +
        'radial-gradient(ellipse 30% 22% at 88% 18%, #087FC2 0 14%, transparent 30%), ' +
        'linear-gradient(180deg, #079DD0 0%, #079DD0 100%)'
    },
    walnut: '#B27A69',
    white: '#FFFFFF'
  };

  /* Subtle stonewashed linen/gauze: angled, low-contrast washes over a
     dominant base. Same recipe for every Léa color — only the three HEX
     values change. Not radial/blob like Cottonways Ink/Topaz/Peacock.
     Uses HEX+00 instead of `transparent` so interpolations stay on-hue. */
  function stonewashSwatch(base, dark, highlight) {
    return {
      type: 'texture',
      base: base,
      value:
        'linear-gradient(116deg, ' + highlight + '00 12%, ' + highlight + '5A 28%, ' + highlight + '00 46%), ' +
        'linear-gradient(22deg, ' + dark + '00 34%, ' + dark + '52 48%, ' + dark + '00 64%), ' +
        'linear-gradient(164deg, ' + highlight + '00 52%, ' + highlight + '40 66%, ' + highlight + '00 80%), ' +
        'linear-gradient(74deg, ' + dark + '00 6%, ' + dark + '3D 18%, ' + dark + '00 32%), ' +
        'linear-gradient(198deg, ' + dark + '00 70%, ' + dark + '38 82%, ' + dark + '00 94%), ' +
        'linear-gradient(48deg, ' + highlight + '00 38%, ' + highlight + '33 50%, ' + highlight + '00 62%), ' +
        'linear-gradient(180deg, ' + base + ' 0%, ' + base + ' 100%)'
    };
  }

  var leaLucColors = {
    beige: stonewashSwatch('#C8AD8C', '#A98767', '#E2CEB2'),
    black: stonewashSwatch('#252523', '#171816', '#44443F'),
    'blue jeans': stonewashSwatch('#7897B2', '#587893', '#A8C0D3'),
    camel: stonewashSwatch('#C69A69', '#A77B50', '#DDC09B'),
    'duck green': stonewashSwatch('#747E70', '#596458', '#98A294'),
    fuchsia: stonewashSwatch('#F42E68', '#CE1E50', '#FA648A'),
    green: stonewashSwatch('#38A873', '#25865B', '#69C297'),
    grey: stonewashSwatch('#A5A7A7', '#858889', '#C8CAC9'),
    khaki: stonewashSwatch('#8B8D76', '#6E715D', '#AEB09A'),
    'light pink': stonewashSwatch('#C38F8D', '#A36F6D', '#DBAFAD'),
    'lt grey': stonewashSwatch('#C7C8C7', '#A8AAAA', '#E0E1DF'),
    mauve: stonewashSwatch('#C7A0AE', '#A77F8E', '#DEC2CB'),
    mustard: stonewashSwatch('#D4A62F', '#B48620', '#E8C75C'),
    navy: stonewashSwatch('#485779', '#303D60', '#6C7896'),
    'neon pink': stonewashSwatch('#F53677', '#D72060', '#FA70A0'),
    orange: stonewashSwatch('#EBA247', '#D27D29', '#F5C26E'),
    pink: stonewashSwatch('#E59AB4', '#CD7898', '#F1BCCF'),
    red: stonewashSwatch('#D93437', '#B92429', '#E96362'),
    royal: stonewashSwatch('#1682E0', '#0862BF', '#45A4EB'),
    'sky blue': stonewashSwatch('#91B4CE', '#7197B5', '#B9D0DF'),
    taupe: stonewashSwatch('#A79B8D', '#887D70', '#C6BBAE'),
    wasabi: stonewashSwatch('#8C9426', '#68701D', '#B1B73A'),
    white: stonewashSwatch('#F1F0E9', '#DAD9D1', '#FAF9F4')
  };

  /* Vendor-keyed color libraries. Entries are either a HEX string (solid) or
     { type: 'solid'|'texture', value: '...' }. Lookups are scoped by
     product.vendor so Cottonways names (e.g. Coral) are not applied to other
     brands. Picker/availability stays the same. */
  var colorLibraries = {
    cottonways: cottonwaysColors,
    'lea-luc': leaLucColors
  };

  function vendorLibraryKey(vendor) {
    var s = String(vendor || '').trim().toLowerCase();
    try {
      s = s.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    } catch (err) {}
    return s
      .replace(/&/g, ' ')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function getVendorColorLibrary(vendor) {
    var key = vendorLibraryKey(vendor);
    if (key && Object.prototype.hasOwnProperty.call(colorLibraries, key)) {
      return colorLibraries[key];
    }
    return null;
  }

  function normalizeColorKey(name) {
    return String(name || '')
      .trim()
      .toLowerCase()
      .replace(/\s+/g, ' ');
  }

  /* Swatch HEX lookup only — does not alter native Shopify option values. */
  function stripLegacySizeSuffix(name) {
    return String(name || '')
      .replace(/\s*\/\s*size\s*(?:osfm|[0-4])\s*$/i, '')
      .replace(/\s+size\s*(?:osfm|[0-4])\s*$/i, '')
      .trim();
  }

  var colorAliases = {
    cirtus: 'citrus',
    sealgass: 'seaglass',
    titianium: 'titanium',
    'light amethyst': 'amethyst',
    'sunshine yellow': 'sunshine',
    'fire coral': 'fire',
    /* Rosee → Rosée; never map to Rose */
    rosee: 'rosée'
  };

  function resolveColorKey(name) {
    var key = normalizeColorKey(stripLegacySizeSuffix(name));
    if (Object.prototype.hasOwnProperty.call(colorAliases, key)) {
      key = colorAliases[key];
    }
    return key;
  }

  function isColorOption(name) {
    return /\bcolou?r\b/i.test(String(name || ''));
  }

  /* Combined labels such as Color/Size, Color and Size, Size & Color. */
  function isCombinedColorSizeLabel(name) {
    var n = String(name || '');
    return /\bcolou?r\b/i.test(n) && /\bsize\b/i.test(n);
  }

  /* Size codes only — not "Acacia/ Size OSFM" color values. */
  function looksLikeSizeValue(value) {
    var v = String(value || '').trim();
    if (!v) return false;
    if (/^\d+\s*\(/i.test(v)) return true;
    if (/^(osfm|s\/m|l\/xl)$/i.test(v)) return true;
    return false;
  }

  /* Color-dot overlay clips every native on the form. If any option is not a
     genuine standalone Color (or a normal Size), skip the whole enhancement
     and leave Shopify's selectors usable. Does not rewrite product data. */
  function formShouldSkipColorDots(form, wrappers) {
    var i;
    var j;
    var wrapper;
    var select;
    var label;
    var opt;
    for (i = 0; i < wrappers.length; i++) {
      wrapper = wrappers[i];
      select = wrapper.querySelector('.single-option-selector');
      if (!select) continue;
      label = resolveOptionLabel(wrapper, select, form);
      if (isCombinedColorSizeLabel(label)) return true;
      if (!isColorOption(label)) continue;
      for (j = 0; j < select.options.length; j++) {
        opt = select.options[j];
        if (!opt.value) continue;
        if (looksLikeSizeValue(opt.value)) return true;
      }
    }
    return false;
  }

  function getColorSwatch(name, vendor) {
    var library = getVendorColorLibrary(vendor);
    if (!library) return null;
    var key = resolveColorKey(name);
    if (!Object.prototype.hasOwnProperty.call(library, key)) return null;
    var entry = library[key];
    if (typeof entry === 'string') {
      return entry ? { type: 'solid', value: entry } : null;
    }
    if (entry && typeof entry === 'object') {
      var type = String(entry.type || '').toLowerCase();
      var value = typeof entry.value === 'string' ? entry.value : '';
      if ((type === 'solid' || type === 'texture') && value) {
        var spec = { type: type, value: value };
        if (typeof entry.base === 'string' && entry.base) spec.base = entry.base;
        return spec;
      }
    }
    return null;
  }

  /* HEX-only. Texture entries return null — use getColorSwatch for rendering. */
  function getColorHex(name, vendor) {
    var spec = getColorSwatch(name, vendor);
    if (spec && spec.type === 'solid') return spec.value;
    return null;
  }

  /* User-facing label only — never alters Shopify option values. */
  function getColorDisplayName(name) {
    var key = resolveColorKey(name);
    if (key === 'rosée') return 'Rosée';
    if (!key) return '';
    return key.replace(/\b([a-zà-öø-ÿ])/g, function (m, ch) {
      return ch.toUpperCase();
    });
  }

  function hexLuminance(hex) {
    var h = String(hex || '').replace('#', '');
    if (h.length === 3) {
      h = h.charAt(0) + h.charAt(0) + h.charAt(1) + h.charAt(1) + h.charAt(2) + h.charAt(2);
    }
    if (h.length !== 6) return -1;
    var r = parseInt(h.slice(0, 2), 16);
    var g = parseInt(h.slice(2, 4), 16);
    var b = parseInt(h.slice(4, 6), 16);
    if (isNaN(r) || isNaN(g) || isNaN(b)) return -1;
    return 0.299 * r + 0.587 * g + 0.114 * b;
  }

  function isLightHex(hex) {
    return hexLuminance(hex) >= 210;
  }

  /* Generic outline for pale textures (e.g. ivory/lt grey on a white menu).
     Name-agnostic — uses the swatch base luminance only. */
  function isPaleTextureBase(hex) {
    return hexLuminance(hex) >= 190;
  }

  function getOptionLabel(wrapper) {
    var label = wrapper && wrapper.querySelector('label');
    return label ? label.textContent.trim() : '';
  }

  function closestAddToCartForm(el) {
    var node = el;
    while (node && node.nodeType === 1) {
      if (node.id === 'AddToCartForm') return node;
      node = node.parentNode;
    }
    return document.getElementById('AddToCartForm');
  }

  /* Presentation only — never writes to native selects. */
  function getFormProduct(form) {
    if (!form) return null;
    try {
      if (window.jQuery) {
        var fromJquery = window.jQuery(form).data('product');
        if (typeof fromJquery === 'string') {
          fromJquery = JSON.parse(fromJquery);
        }
        if (fromJquery && fromJquery.options && fromJquery.options.length) {
          return fromJquery;
        }
      }
      var raw = form.getAttribute('data-product');
      if (!raw) return null;
      var parsed = JSON.parse(raw);
      if (parsed && parsed.options && parsed.options.length) return parsed;
    } catch (err) {}
    return null;
  }

  function getProductVendor(form) {
    var product = getFormProduct(form);
    return product && product.vendor ? String(product.vendor) : '';
  }

  function colorLabelForVendor(name, vendor) {
    if (getVendorColorLibrary(vendor)) {
      return getColorDisplayName(name);
    }
    return String(name || '');
  }

  function optionNameFromProduct(form, select) {
    var product = getFormProduct(form);
    if (!product) return '';
    var index = 0;
    var dataOption = select && select.getAttribute('data-option');
    var match = dataOption && /^option(\d+)$/i.exec(dataOption);
    if (match) {
      index = parseInt(match[1], 10) - 1;
    }
    if (isNaN(index) || index < 0 || index >= product.options.length) return '';
    var opt = product.options[index];
    var name = typeof opt === 'string' ? opt : (opt && opt.name) || '';
    return String(name).replace(/:\s*$/, '').trim();
  }

  function getPlaceholderText(select, optionLabel) {
    var empty = select.querySelector('option[value=""]');
    if (empty && empty.textContent.trim()) {
      return empty.textContent.trim();
    }
    return 'Select a ' + (optionLabel || 'option');
  }

  /* Prefer the visible option name; then product JSON; then placeholder text. */
  function resolveOptionLabel(wrapper, select, form) {
    var label = getOptionLabel(wrapper);
    if (label) return label.replace(/:\s*$/, '');
    var fromProduct = optionNameFromProduct(form || closestAddToCartForm(wrapper || select), select);
    if (fromProduct) return fromProduct;
    var placeholder = getPlaceholderText(select, '');
    var match = placeholder.match(/select\s+an?\s+(.+)$/i);
    if (match && match[1]) {
      return match[1].replace(/:\s*$/, '').trim();
    }
    return '';
  }

  /* Theme required-selection only keeps a value if this click is marked
     as an explicit customer pick. Without these attrs, reconcileSelections()
     clears both natives ~50ms after our synthetic change. */
  function markExplicitUserPick(select, value) {
    select.setAttribute('data-cw-user-pick', '1');
    if (value) {
      select.setAttribute('data-cw-user-value', value);
    } else {
      select.removeAttribute('data-cw-user-value');
    }
  }

  function optionStillAvailable(select, value) {
    if (!value) return false;
    for (var i = 0; i < select.options.length; i++) {
      if (select.options[i].value === value && !select.options[i].disabled) {
        return true;
      }
    }
    return false;
  }

  /* OptionSelectors fills the other dropdown with the first matching
     variant (e.g. Acacia). That is not a customer Color pick. If the
     customer did pick that option, keep it only while it remains valid. */
  function clearUnpickedSiblings(form, exceptSelect) {
    if (!form) return;
    var selects = form.querySelectorAll('.single-option-selector');
    Array.prototype.forEach.call(selects, function (sel) {
      if (sel === exceptSelect) return;
      var wanted = sel.getAttribute('data-cw-user-value') || '';
      if (wanted && optionStillAvailable(sel, wanted)) {
        if (sel.value !== wanted) sel.value = wanted;
        return;
      }
      if (wanted) sel.removeAttribute('data-cw-user-value');
      if (sel.value) sel.value = '';
    });
  }

  /* Same-turn ATC gate. theme.js selectCallback enables Add to Cart as soon
     as OptionSelectors finds any matching variant (often Size + first Color).
     Required-selection disables ~50ms later if another option is still empty.
     Only disable here — never enable, never rewrite button text, never fire
     extra change events. Completing the last option leaves Shopify's enable. */
  function disableAddIfIncomplete(form) {
    if (!form) return;
    var incomplete = false;
    var selects = form.querySelectorAll('.single-option-selector');
    Array.prototype.forEach.call(selects, function (sel) {
      var realOptions = 0;
      for (var i = 0; i < sel.options.length; i++) {
        if (sel.options[i].value) realOptions += 1;
      }
      if (realOptions > 1 && !sel.value) incomplete = true;
    });
    if (!incomplete) return;
    var btn = form.querySelector('.add');
    if (!btn) return;
    btn.disabled = true;
    btn.setAttribute('disabled', 'disabled');
    if (btn.classList) btn.classList.add('disabled');
  }

  function setNativeSelectValue(select, value) {
    markExplicitUserPick(select, value);
    if (select.value !== value) {
      select.value = value;
    }
    /* Do not wrap Shopify's change handlers. Bold/Clever throwing there
       must not teardown the overlay. */
    if (window.jQuery) {
      jQuery(select).trigger('change');
    } else {
      select.dispatchEvent(new Event('change', { bubbles: true }));
    }
    var form = closestAddToCartForm(select);
    try {
      clearUnpickedSiblings(form, select);
      disableAddIfIncomplete(form);
      if (form) refreshAll(form);
    } catch (err) {
      failSafeRestoreNatives(form, err);
    }
    return true;
  }

  function closeAll(exceptRoot) {
    document.querySelectorAll('.cw-vd.is-open').forEach(function (root) {
      if (exceptRoot && root === exceptRoot) return;
      root.classList.remove('is-open');
      var trigger = root.querySelector('.cw-vd__trigger');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
      var menu = root.querySelector('.cw-vd__menu');
      if (menu) menu.hidden = true;
    });
  }

  function refreshAll(form) {
    if (!form || form.getAttribute(FAIL_ATTR) === '1') return;
    try {
      form.querySelectorAll('.cw-vd').forEach(function (root) {
        if (typeof root._cwVdRefresh === 'function') {
          root._cwVdRefresh();
        }
      });
    } catch (err) {
      failSafeRestoreNatives(form, err);
    }
  }

  /* OptionSelectors can leave duplicate wrappers after Theme Editor re-init. */
  function getBindableWrappers(form) {
    var wrappers = Array.prototype.slice.call(form.querySelectorAll('.selector-wrapper'));
    var byKey = {};
    var order = [];

    wrappers.forEach(function (wrapper, index) {
      var select = wrapper.querySelector('.single-option-selector');
      if (!select) return;
      var key =
        select.getAttribute('data-option') ||
        select.id ||
        resolveOptionLabel(wrapper, select, form) ||
        ('wrapper-' + index);
      if (!Object.prototype.hasOwnProperty.call(byKey, key)) {
        order.push(key);
      }
      byKey[key] = wrapper;
    });

    return order.map(function (key) {
      return byKey[key];
    });
  }

  function appendColorSwatch(parent, name, vendor) {
    var spec = getColorSwatch(name, vendor);
    if (!spec) return;
    var swatch = document.createElement('span');
    swatch.className = 'cw-vd__swatch';
    swatch.setAttribute('aria-hidden', 'true');
    if (spec.type === 'texture') {
      swatch.style.background = spec.value;
      swatch.style.backgroundRepeat = 'no-repeat';
      swatch.style.backgroundSize = '100% 100%';
      if (spec.base && isPaleTextureBase(spec.base)) {
        swatch.classList.add('cw-vd__swatch--light');
      }
    } else {
      swatch.style.backgroundColor = spec.value;
      if (isLightHex(spec.value)) {
        swatch.classList.add('cw-vd__swatch--light');
      }
    }
    parent.appendChild(swatch);
  }

  function bindDropdown(form, wrapper, index) {
    if (wrapper.getAttribute(INIT_ATTR) === 'true') return;

    var select = wrapper.querySelector('.single-option-selector');
    if (!select) return;

    var optionLabel = resolveOptionLabel(wrapper, select, form);
    var isColor = isColorOption(optionLabel);
    var vendor = getProductVendor(form);

    var mount = form.querySelector('.cw-vd-mount');
    if (!mount) return;

    var root = document.createElement('div');
    root.className = 'cw-vd cw-vd--option';
    root.setAttribute('data-cw-vd-index', String(index));

    var optionName = document.createElement('span');
    optionName.className = 'cw-vd__label-text';
    optionName.textContent = optionLabel;

    var trigger = document.createElement('button');
    trigger.type = 'button';
    trigger.className = 'cw-vd__trigger';
    trigger.setAttribute('aria-haspopup', 'listbox');
    trigger.setAttribute('aria-expanded', 'false');

    var triggerInner = document.createElement('span');
    triggerInner.className = 'cw-vd__trigger-inner';

    var triggerText = document.createElement('span');
    triggerText.className = 'cw-vd__trigger-text';

    var chevron = document.createElement('span');
    chevron.className = 'cw-vd__chevron';
    chevron.setAttribute('aria-hidden', 'true');

    triggerInner.appendChild(triggerText);
    trigger.appendChild(triggerInner);
    trigger.appendChild(chevron);

    var menu = document.createElement('div');
    menu.className = 'cw-vd__menu';
    menu.hidden = true;
    menu.setAttribute('role', 'listbox');

    root.appendChild(optionName);
    root.appendChild(trigger);
    root.appendChild(menu);
    mount.appendChild(root);

    function syncTrigger() {
      var value = select.value;
      var placeholder = getPlaceholderText(select, optionLabel);

      triggerInner.innerHTML = '';
      triggerText = document.createElement('span');
      triggerText.className = 'cw-vd__trigger-text';

      if (!value) {
        triggerText.textContent = placeholder;
        triggerInner.appendChild(triggerText);
        return;
      }

      if (isColor) {
        appendColorSwatch(triggerInner, value, vendor);
        triggerText.textContent = colorLabelForVendor(value, vendor);
      } else {
        triggerText.textContent = value;
      }
      triggerInner.appendChild(triggerText);
    }

    function rebuildMenu() {
      menu.innerHTML = '';
      var placeholder = getPlaceholderText(select, optionLabel);
      var currentValue = select.value;

      var placeholderBtn = document.createElement('button');
      placeholderBtn.type = 'button';
      placeholderBtn.className = 'cw-vd__option cw-vd__option--placeholder';
      placeholderBtn.textContent = placeholder;
      placeholderBtn.setAttribute('data-value', '');
      if (!currentValue) placeholderBtn.classList.add('is-selected');
      menu.appendChild(placeholderBtn);

      Array.prototype.forEach.call(select.options, function (opt) {
        if (!opt.value) return;

        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'cw-vd__option';
        btn.setAttribute('data-value', opt.value);

        if (opt.disabled) {
          btn.disabled = true;
          btn.classList.add('is-disabled');
        }

        if (opt.value === currentValue) {
          btn.classList.add('is-selected');
        }

        if (isColor) {
          appendColorSwatch(btn, opt.value, vendor);
          var optText = document.createElement('span');
          optText.textContent = colorLabelForVendor(opt.value, vendor);
          btn.appendChild(optText);
        } else {
          btn.textContent = opt.textContent.trim();
        }
        menu.appendChild(btn);
      });
    }

    function chooseValue(value) {
      try {
        closeAll();
        setNativeSelectValue(select, value);
        syncTrigger();
        rebuildMenu();
      } catch (err) {
        failSafeRestoreNatives(form, err);
        return;
      }
      window.setTimeout(function () {
        refreshAll(form);
      }, 55);
    }

    trigger.addEventListener('click', function (e) {
      try {
        e.preventDefault();
        e.stopPropagation();
        var willOpen = !root.classList.contains('is-open');
        closeAll(willOpen ? root : null);
        root.classList.toggle('is-open', willOpen);
        trigger.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
        menu.hidden = !willOpen;
        if (willOpen) rebuildMenu();
      } catch (err) {
        failSafeRestoreNatives(form, err);
      }
    });

    menu.addEventListener('click', function (e) {
      var btn = e.target.closest('.cw-vd__option');
      if (!btn || btn.disabled) return;
      e.preventDefault();
      e.stopPropagation();
      chooseValue(btn.getAttribute('data-value') || '');
    });

    select.addEventListener('change', function () {
      try {
        syncTrigger();
        rebuildMenu();
      } catch (err) {
        failSafeRestoreNatives(form, err);
      }
    });

    var observer = new MutationObserver(function () {
      try {
        syncTrigger();
        rebuildMenu();
      } catch (err) {
        failSafeRestoreNatives(form, err);
      }
    });
    observer.observe(select, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled'] });

    wrapper.setAttribute(INIT_ATTR, 'true');
    root._cwVdObserver = observer;
    root._cwVdSelect = select;
    root._cwVdRefresh = function () {
      syncTrigger();
      rebuildMenu();
    };

    syncTrigger();
    rebuildMenu();
  }

  function teardownForm(form) {
    if (!form) return;

    form.classList.remove(FORM_CLASS);
    form.querySelectorAll('.cw-vd').forEach(function (root) {
      if (root._cwVdObserver) root._cwVdObserver.disconnect();
      root.remove();
    });
    form.querySelectorAll('.selector-wrapper[' + INIT_ATTR + ']').forEach(function (wrapper) {
      wrapper.removeAttribute(INIT_ATTR);
    });
    if (window.jQuery) {
      jQuery(form).off('change.cwVd');
    }
    form.removeAttribute('data-cw-vd-init');
    form.removeAttribute(SKIP_ATTR);
    form._cwVdChangeBound = false;
  }

  /* After overlay teardown or an eligibility skip, required-selection
     still only treats data-cw-user-pick / swatch radios as customer
     picks. Mark native <select> changes as picks so Size/Color remain
     orderable. Capture phase, so it runs before required-selection.
     Does not fire change. */
  function attachFailSafeNativeBridge(form) {
    if (!form || form._cwVdFailSafeBridge) return;
    form._cwVdFailSafeBridge = true;
    form.addEventListener(
      'change',
      function (e) {
        if (form.getAttribute(FAIL_ATTR) !== '1' && form.getAttribute(SKIP_ATTR) !== '1') return;
        var t = e.target;
        if (!t || !t.classList || !t.classList.contains('single-option-selector')) return;
        t.setAttribute('data-cw-user-pick', '1');
        if (t.value) t.setAttribute('data-cw-user-value', t.value);
        else t.removeAttribute('data-cw-user-value');
      },
      true
    );
  }

  /* Post-init overlay exception: unclip natives / theme swatches and stop
     overlay retries. Does not clear native values, does not trigger change,
     and does not re-init — so this cannot wipe a customer pick. */
  function failSafeRestoreNatives(form, err) {
    if (!form || form.getAttribute(FAIL_ATTR) === '1') return;
    form.setAttribute(FAIL_ATTR, '1');
    try {
      if (typeof console !== 'undefined' && console.warn) {
        console.warn('[cw-vd] overlay failed after init; restoring native selectors', err);
      }
    } catch (logErr) {}
    teardownForm(form);
    attachFailSafeNativeBridge(form);
  }

  function initForm(form) {
    if (!form || form.getAttribute(FAIL_ATTR) === '1') return false;
    if (form.getAttribute(SKIP_ATTR) === '1') return true;
    if (form.getAttribute('data-cw-vd-init') === 'true') return true;

    var wrappers = getBindableWrappers(form);
    if (!wrappers.length) return false;

    if (formShouldSkipColorDots(form, wrappers)) {
      form.setAttribute(SKIP_ATTR, '1');
      attachFailSafeNativeBridge(form);
      return true;
    }

    var mount = form.querySelector('.cw-vd-mount');
    if (!mount) return false;

    try {
      wrappers.forEach(function (wrapper, index) {
        bindDropdown(form, wrapper, index);
      });
    } catch (err) {
      teardownForm(form);
      return false;
    }

    /* Hide natives only after custom dropdowns exist. If overlay JS throws
       during bind, customers keep Shopify's native selectors. */
    if (!form.querySelector('.cw-vd')) return false;
    form.classList.add(FORM_CLASS);

    if (!form._cwVdChangeBound) {
      form._cwVdChangeBound = true;
      var onNativeChange = function (e) {
        if (!e.target.classList || !e.target.classList.contains('single-option-selector')) {
          return;
        }
        refreshAll(form);
        window.setTimeout(function () {
          refreshAll(form);
        }, 55);
      };
      if (window.jQuery) {
        jQuery(form).on('change.cwVd', '.single-option-selector', function () {
          refreshAll(form);
          window.setTimeout(function () {
            refreshAll(form);
          }, 55);
        });
      }
      form.addEventListener('change', onNativeChange, true);
    }

    form.setAttribute('data-cw-vd-init', 'true');
    return true;
  }

  function waitAndInit(scope) {
    var form = (scope || document).querySelector('#AddToCartForm');
    if (!form) return;

    var attempts = 0;
    var maxAttempts = 40;

    function tryInit() {
      if (form.getAttribute(FAIL_ATTR) === '1') return;
      if (form.getAttribute(SKIP_ATTR) === '1') return;
      attempts += 1;
      if (initForm(form)) return;
      if (attempts < maxAttempts) {
        window.setTimeout(tryInit, 100);
      }
    }

    window.setTimeout(tryInit, 300);
  }

  function onSectionLoad(event) {
    var section = event.target;
    if (!section || !section.querySelector || !section.querySelector('#AddToCartForm')) return;
    var form = section.querySelector('#AddToCartForm');
    /* Theme editor: allow a fresh bind after the merchant reloads the section. */
    form.removeAttribute(FAIL_ATTR);
    form.removeAttribute(SKIP_ATTR);
    teardownForm(form);
    waitAndInit(section);
  }

  document.addEventListener('click', function () {
    closeAll();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAll();
  });

  document.addEventListener('shopify:section:load', onSectionLoad);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      waitAndInit(document);
    });
  } else {
    waitAndInit(document);
  }

  window.CWVariantDropdowns = {
    colors: cottonwaysColors,
    libraries: colorLibraries,
    vendorLibraryKey: vendorLibraryKey,
    getColorSwatch: getColorSwatch,
    getColorHex: getColorHex,
    init: waitAndInit,
    teardown: teardownForm,
    failSafe: function (form) {
      failSafeRestoreNatives(form || document.getElementById('AddToCartForm'), new Error('test'));
    }
  };
})();
